var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Paper',{staticClass:"myTender"},[_c('Table',{attrs:{"tableData":_vm.tableData,"tableHeaders":_vm.tableHeaders}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }